import StyledSvg from 'icons/StyledSvg';
import { IconProps } from 'icons/types';

export const ArrowSmall = ({ color, size = '16', height = '16', rotation }: IconProps) => {
  return (
    <StyledSvg
      width={size}
      height={height}
      viewBox="0 0 16 16"
      color={color || 'currentColor'}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle fill={color || 'currentColor'} cx="8" cy="8" r="8" />
      <g transform={`rotate(${rotation ? rotation : 0} 8 8)`}>
        <polyline fill="none" stroke="#FFFFFF" strokeWidth="1.5" points="4.4,8.5 8,4.9 11.6,8.5" />
        <line fill="none" stroke="#FFFFFF" strokeWidth="1.5" x1="8" y1="13" x2="8" y2="5.5" />
      </g>
    </StyledSvg>
  );
};
